import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="flex justify-center bg-black/30 p-10">
        <p className="text-white text-center">© 2021 Güven Karabulut</p>
      </div>
    </div>
  );
};

export default Footer;
